import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { IProductLoaderState } from '../../interfaces/product-loader.interface';
import { ProductLoaderService } from '../../services/product-loader/product-loader.service';

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-product-loader',
  templateUrl: './product-loader.component.html',
  styleUrls: ['./product-loader.component.scss'],
})

/**
 * Clase del componente carga del producto
 *
 * *Product loader component class*
 */
export class ProductLoaderComponent implements OnInit, OnDestroy {

  /**
   * Declaración para la subscripción del componente al servicio de ProductLoaderService
   *
   * *Declaration for Component subscriptions to ProductLoaderService *
   *
   * @access              private
   * @type                {Subscription}
   */
  private subscription: Subscription;

  /**
   * Declaración del estado para mostrar el componente
   *
   * *Declaration for component loading*
   *
   * @access              private
   * @type                {boolean}
   */
  show = false;

  /**
   * Declaración del mensaje de muestra del componente
   *
   * *Declaration for component message*
   *
   * @access              private
   * @type                {string}
   */
  msg = '';

  currentValueLoad = 0;

  timer = 0;

  percentValue = 0;
  /**
   * Flag que nos permite activar el contador de porcentage
   *
   * *Flag that allows us to activate the percentage countere*
   *
   * @access              private
   * @type                {boolean}
   */
  activePer = false;

  /**
   * Declaración del porcentage del proceso de muestra del componente
   *
   * *Declaration of the percentage of the component sample process*
   *
   * @access              private
   * @type                {number}
   */
  percentage = 0;

  interval;

  /**
   * Summary      Constructor of the component.
   *
   * @param {ProductLoaderService}  productLoaderService  Injectable productLoaderService service.
   */
  constructor(
    private productLoaderService: ProductLoaderService,
  ) { }

  /**
   * Función de Angular ejecutada una vez el componente sea cargado, subscripción al servicion
   *
   * *Angular function that is run when the component is loaded, service subscription*
   */
  ngOnInit() {
    this.subscription = this.productLoaderService.loaderState
      .subscribe((state: IProductLoaderState) => {
        this.show = state.show;
        this.msg = state.msg;
        this.timer = state.timer ? state.timer : 5000;
        if (!this.show) {
          return;
        }
        this.percentValue = 0;
        let seg = this.timer / 1000;
        setTimeout(async () => {
          for (let index = 0; index < seg; index ++) {
            await new Promise(r => setTimeout(r, 1000));
            this.currentValueLoad += 1000;
            this.percentValue = Math.trunc((this.currentValueLoad / this.timer) * 100);

          }
          this.currentValueLoad = 0;
        }, 100);
      });
  }

  /**
   * Función de Angular ejecutada una vez el componente sea destruido, dessubscripción al servicion
   *
   * *Angular function that is run when the component is destroyed, service unsubscription*
   */
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
